export default __webpack_public_path__ + "527294b0eeed9513976b8b29e0b79638.png";